/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { Tab, withStyles } from "@material-ui/core";

const CustomTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    minWidth: 50,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: 0,
    "&:hover": {
      color: theme.palette.primary.main,
      opacity: 1,
    },
    "&$selected": {
      color: "#ffffff",
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.primary.main,
    },
  },
  selected: {},
}))((props) => <Tab {...props} />);

const TabWithRef = React.forwardRef((props, ref) => {
  return (
    <div ref={ref}>
      <CustomTab {...props} />
    </div>
  );
});
export default TabWithRef;
